import { mapCoralProductPage, mapProductPage } from '@websrc/DataMappers/mapProductPage'
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'

import { getUser } from '../Helpers/authManager'
import { isUnderTest } from '../Helpers/isUnderTest'
import { useHasConsent } from '../Hooks/useHasConsent/useHasConsent'

const genSHA256Hash = async (message: string) => {
  const msgUint8 = new TextEncoder().encode(message) // encode as (utf-8) Uint8Array
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8) // hash the message
  const hashArray = Array.from(new Uint8Array(hashBuffer)) // convert buffer to byte array
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('') // convert bytes to hex string

  return hashHex
}

export const pinterestTrack = (
  eventType: 'Checkout' | 'AddToCart' | 'PageVisit',
  data?: Record<string, any>
) => window.pintrk?.('track', eventType, data)

export const PinterestPixel: React.FC<{
  productDetails?: ReturnType<typeof mapProductPage | typeof mapCoralProductPage>['product_details']
  path: string
}> = ({ productDetails, path }) => {
  const hasConsent = useHasConsent(['thirdparty'])

  const pinterestId = process.env.PINTEREST_ID

  const [userEmail, setUserEmail] = useState<
    undefined | null | { email: string; hashedEmail: string }
  >(undefined)

  useEffect(() => {
    if (isUnderTest()) return
    const pageVisitData = productDetails ? { product_id: productDetails.product_number } : {}
    pinterestTrack('PageVisit', pageVisitData)
  }, [productDetails, path])

  useEffect(() => {
    if (isUnderTest()) return
    if (hasConsent && pinterestId) {
      const setEmail = async () => {
        try {
          const user = await getUser()
          const email = user?.profile.email

          if (email) {
            const hashedEmail = await genSHA256Hash(email)
            setUserEmail({ email, hashedEmail })
          } else {
            setUserEmail(null)
          }
        } catch (_error: unknown) {
          setUserEmail(null)
        }
      }

      void setEmail()
    }
  }, [hasConsent, pinterestId])

  if (isUnderTest()) return

  const emailString = userEmail ? `'${userEmail.email}'` : 'null'
  const hashedEmailString = userEmail ? userEmail.hashedEmail : 'null'

  return userEmail !== undefined ? (
    <Helmet>
      <script type={'text/javascript'}>
        {`
        !function(e){if(!window.pintrk){window.pintrk = function () {
          window.pintrk.queue.push(Array.prototype.slice.call(arguments))};var
          n=window.pintrk;n.queue=[],n.version="3.0";var
          t=document.createElement("script");t.async=!0,t.src=e;var
          r=document.getElementsByTagName("script")[0];
          r.parentNode.insertBefore(t,r)}}("https://s.pinimg.com/ct/core.js");
          pintrk('load', '${pinterestId}', {em: ${emailString}});
          pintrk('page');
        `}
      </script>
      <noscript>
        {`<img height="1" width="1" style="display:none;" alt=""
          src="https://ct.pinterest.com/v3/?event=init&tid=${pinterestId}&pd[em]=${hashedEmailString}&noscript=1" />`}
      </noscript>
    </Helmet>
  ) : null
}
